<template>
  <a-drawer width="65%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-row>
        <a-col :span="24">
          <a-form-model-item  :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" :label="$t('活动名称')" prop="activityName" >
            <a-input v-model="form.activityName" :maxLength="128" :placeholder="$t('请输入')+$t('活动名称')" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <a-form-model-item  :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" :label="$t('分享文案')" prop="posterTxt" >
            <a-input v-model="form.posterTxt" :placeholder="$t('请输入')+$t('分享文案')" />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col :span="12">
          <a-form-model-item prop="startTime"  :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
            <span slot="label" ><a-tooltip>{{$t('开始时间')}}<template slot="title">{{$t('开始时间')}}</template></a-tooltip></span>
            <a-date-picker style="width: 100%" v-model="form.startTime" :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item prop="endTime" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
            <span slot="label" ><a-tooltip>{{$t('结束时间')}}<template slot="title">{{$t('结束时间')}}</template></a-tooltip></span>
            <a-date-picker style="width: 100%" v-model="form.endTime"  :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
<!--        <a-col  :span="24">
          <a-form-model-item prop="timeType"  :label-col="{span: 4}" :wrapper-col="{span: 16}">
            <span slot="label" >领取时间段<a-tooltip><template slot="title">领取结束时间</template></a-tooltip>
            </span>
            <a-radio-group v-model="form.timeType">
              <a-radio v-for="(item, index) in this.customDict.ActivityTimeTypeEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>-->
        <a-col :span="24" v-if="form.timeType===2 " >
          <a-form-model-item prop="effectiveTimeList" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
            <span slot="label" ><a-tooltip>{{$t('时间段')}}<template slot="title">{{$t('时间段')}}</template></a-tooltip></span>
            <a-card v-for="(activityTime, index) in form.effectiveTimeList" :key="index" >
              {{$t('每天')}} <a-time-picker v-model="activityTime.startTime" format="HH:mm" valueFormat="HH:mm" />-
              <a-time-picker v-model="activityTime.endTime" format="HH:mm" valueFormat="HH:mm" />
              <a-button type="link" style="color: red"  @click="delUseTimeRange(index)"><a-icon type="delete" />delete</a-button>
            </a-card>
            <div style="width: 50%">
              <a-button type="link"  @click="addUseTimeRange"><a-icon type="plus" />{{$t('添加时段')}} </a-button>
            </div>
          </a-form-model-item>
        </a-col>
        <a-col :span="24" v-if="form.timeType===3 " >
          <a-form-model-item prop="effectiveTimeList" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
            <a-card v-for="(activityTime, index) in form.effectiveTimeList" :key="index" >
              <a-select  mode="multiple" placeholder="请选择周" style="width: 55%" v-model="activityTime.dayOfWeekList" allowClear>
                <a-select-option v-for="(item, index) in customDict.DayOfWeekEnum" :value="item.type" :key="index">{{ item.name }}</a-select-option>
              </a-select>
              <a-time-picker v-model="activityTime.startTime" format="HH:mm" valueFormat="HH:mm" />-
              <a-time-picker v-model="activityTime.endTime" format="HH:mm" valueFormat="HH:mm"/>
              <a-button type="link" style="color: red"  @click="delUseTimeRange(index)"><a-icon type="delete" />delete</a-button>
            </a-card>
            <div>
              <a-button type="link"  @click="addUseTimeRange"><a-icon type="plus" />{{$t('添加时段')}}</a-button>
            </div>
          </a-form-model-item>
        </a-col>
        <a-col :span="24" v-if="form.timeType===4 " >
          <a-form-model-item prop="effectiveTimeList" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
            <a-card v-for="(activityTime, index) in form.effectiveTimeList" :key="index" >
              <a-select  mode="multiple" placeholder="请选择月" style="width: 55%" v-model="activityTime.monthOfYearList" allowClear>
                <a-select-option v-for="(item, index) in customDict.MonthOfYearEnum" :value="item.type" :key="index">{{ item.name }}</a-select-option>
              </a-select>
              <a-time-picker v-model="activityTime.startTime" format="HH:mm" valueFormat="HH:mm" />-
              <a-time-picker v-model="activityTime.endTime" format="HH:mm" valueFormat="HH:mm"/>
              <a-button type="link" style="color: red"  @click="delUseTimeRange(index)"><a-icon type="delete" />delete</a-button>
            </a-card>
            <div>
              <a-button type="link"  @click="addUseTimeRange"><a-icon type="plus" />{{$t('添加时段')}}</a-button>
            </div>
          </a-form-model-item>
        </a-col>
      </a-row>
      <div style="height: 20px"></div>
      <a-row>
        <a-col  :span="12">
          <a-form-model-item :label="$t('活动封面图')" prop="coverPic"  :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
            <oss-upload-single :height="100" :width="100"  v-model="form.coverPic" prefix="goods" type="img"/>
            <span>Recommended size 351 x 175</span>
          </a-form-model-item>
        </a-col>
        <a-col  :span="12">
          <a-form-model-item :label="$t('分享海报图')" prop="posterPic"  :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
            <oss-upload-single :height="100" :width="100"  v-model="form.posterPic" prefix="goods" type="img"/>
            <span>Recommended size 351 x 175</span>
          </a-form-model-item>
        </a-col>
        <a-col  :span="12">
          <a-form-model-item :label="$t('是否上架')" prop="status" class="margin-bottom-10" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
            <a-radio-group v-model="form.status"  button-style="solid">
              <a-radio-button v-for="(item, index) in this.customDict.ActivitySaleStatusEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item prop="limitNum"  :label-col="{span: 8}" :wrapper-col="{span: 12}">
            <span slot="label" >
              <a-tooltip>
                {{$t('单用户限购数')}}<template slot="title"> {{$t('单用户限购数')}}</template>
              </a-tooltip>
            </span>
            <a-input v-model="form.limitNum" oninput="value=value.replace(/[^\d]/g,'')"  :placeholder="$t('请输入')+$t('单用户限购数')" />
          </a-form-model-item>
        </a-col>
        <a-col  :span="12">
          <a-form-model-item :label="$t('排序')" prop="sort" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
            <a-input-number style="width: 100%" v-model="form.sort" @change="limitSort" :placeholder="$t('请输入')+$t('排序')" />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-form-model-item :label="$t('选择商品')" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
        <div @click="openProdSelect" style="width: 100px">
          <a-button type="dashed" @click="openProdSelect" danger>
            <span style="color: dodgerblue"> {{$t('选择商品')}}</span>
          </a-button>
        </div>
      </a-form-model-item>
      <a-table v-if="this.form.goodsList.length>0"
               :loading="goodsLoading"
               rowKey="id"
               :size="tableSize"
               :columns="goodsColumns"
               :data-source="form.goodsList"
               :pagination="false"
               :bordered="tableBordered">
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <template slot="picture" slot-scope="text, record">
          <div>
            <img v-if="record.picture" :src="record.picture"  style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none"/>
          </div>
        </template>

        <span slot="categoryId" slot-scope="text, record">
            {{getCategoryNameById(record.categoryId)}}
        </span>
        <span slot="brandId" slot-scope="text, record">
             {{getBrandNameById(record.brandId)}}
          </span>
        <span slot="status" slot-scope="text, record">
           <custom-dict-tag :options="customDict.GoodsStatusEnum" :value="record.status"/>
          </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleGoodsDelete(record.id)">
            <a-icon type="delete" />{{$t('删除')}}
          </a>
        </span>
      </a-table>


<!--      <a-form-model-item :label="$t('活动详情')" prop="description" >
        <editor v-model="form.description" :placeholder="$t('请输入')+$t('活动详情')"/>
      </a-form-model-item>-->
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
    <checkbox-goods-select-form ref="CheckboxGoodsSelectForm" @goodsSelect="indexGoodsModalSelect"></checkbox-goods-select-form>
  </a-drawer>
</template>

<script>
import { getActivity, addActivity, updateActivity ,getActivityRank} from '@/api/activity/activity'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateRdStr, uploadObject, uploadOss} from "@/api/tool/oss";
import {allBrand} from "@/api/goods/brand";
import {listCategory} from "@/api/goods/category";
import Editor from "@/components/Editor/Editor";
import {translation} from "@/api/tool/common";
import CheckboxGoodsSelectForm from "@/views/goods/goods/modules/CheckboxSelectForm";
import { tableMixin } from '@/store/table-mixin'
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";
import moment from 'moment';

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    OssUploadSingle,
    Editor,
    CheckboxGoodsSelectForm,
    CustomDictTag,
  },
  mixins: [tableMixin],
  data () {
    return {
      moment,
      goodsLoading: false,
      goodsColumns: [
        {
          title: this.$t('商品编号'),
          dataIndex: 'id',
        },
        {
          title: this.$t('商品名称'),
          dataIndex: 'goodsName',
        },
        /*{
          title: this.$t('包装单位'),
          width: 60,
          dataIndex: 'unit',
        },*/
        {
          title: this.$t('商品主图'),
          dataIndex: 'picture',
          scopedSlots: {customRender: 'picture'},
        },
        {
          title: this.$t('商品分类'),
          dataIndex: 'categoryId',
          scopedSlots: {customRender: 'categoryId'},
        },
        {
          title: this.$t('秒杀价格'),
          dataIndex: 'seckillPrice',
        },
        {
          title: this.$t('商品状态'),
          dataIndex: 'status',
          scopedSlots: {customRender: 'status'},
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          scopedSlots: {customRender: 'operation'},
        }
      ],
      errorMessage:undefined,
      localeColumns: [
        {
          title: this.$t('语言'),
          dataIndex: 'locale',
          key: 'locale',
          scopedSlots: { customRender: 'locale' }
        }, {
          title: this.$t('活动名称'),
          dataIndex: 'activityName',
          scopedSlots: { customRender: 'activityName' },
          key: 'activityName'
        }, {
          title: this.$t('分享文案'),
          dataIndex: 'posterTxt',
          scopedSlots: { customRender: 'posterTxt' },
          key: 'posterTxt'
        }, {
          title: this.$t('操作'),
          dataIndex: 'action',
          key: 'action',
          width: 20,
          slots: { title: 'addbtn', customRender: 'name' },
          scopedSlots: { customRender: 'action' }
        }
      ],
      activityTypeList:[],
      categoryList: [{id: "0", categoryName: ''}],
      cateOptions: [],
      brandList: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,
        localeList: [],
        timeType: 2,
        effectiveTimeList :[],
        activityType: 1,
        goodsList:[],
        maxBuyNum:6,
        activityName: null,
        isShowCalendar:true,
        startTime: null,

        endTime: null,

        coverPic: null,

        posterPic: null,

        posterTxt: null,

        levelIds: null,

        limitNum: null,

        description: null,

        sort: null,
        status: 1,
        area: null,

        createTime: null,
        localeFieldMap:{},

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        activityType: [
          { required: true, message: this.$t('活动类型 1线上签售')+this.$t('不能为空'), trigger: 'change' }
        ],
        activityName: [
          { required: true, message: this.$t('活动名称')+this.$t('不能为空'), trigger: 'blur' }
        ],
        posterTxt: [
          { required: true, message: this.$t('分享文案')+this.$t('不能为空'), trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: this.$t('开始时间')+this.$t('不能为空'), trigger: 'change' }
        ],
        endTime: [
          { required: true, message: this.$t('结束时间')+this.$t('不能为空'), trigger: 'change' }
        ],
        coverPic: [
          { required: true, message: this.$t('活动封面图')+this.$t('不能为空'), trigger: 'blur' }
        ],
        timeType: [{ required: true, message: '适用时间段'+this.$t('不能为空'), trigger: 'change' }],
        effectiveTimeList: [{ required: true, message: '适用时间段'+this.$t('不能为空'), trigger: 'change' }],
        limitNum: [
          { required: true, message: this.$t('最多参与次数')+this.$t('不能为空'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('是否上架')+this.$t('不能为空'), trigger: 'blur' }
        ],
        sort: [
          { required: true, message: this.$t('排序')+this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.getCateList();
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        localeList: [],
        timeType: 2,
        effectiveTimeList :[],
        goodsList:[],
        activityType: 1,
        activityName: null,
        maxBuyNum:6,
        isShowCalendar:true,
        startTime: null,
        endTime: null,
        coverPic: null,
        posterPic: null,
        status: 1,
        posterTxt: null,
        levelIds: null,
        limitNum: null,
        description: null,
        sort: null,
        area: null,
        createTime: null,
        localeFieldMap:{},
        remark: null,
      }

    },
    handleGoodsDelete(key) {
      const dataSource = [...this.form.goodsList];
      this.form.goodsList = dataSource.filter(item => item.id !== key);
    },
    limitSort(sort) {
      let val = sort;
      if(val==null||val==undefined||val==''|| val<0){
        val=0
      }
      if (val > 999999) {
        val = 999999
      }
      this.form.sort = val
    },

    addUseTimeRange() {
      let data = {"dayOfWeekList": [], "monthOfYearList": [], "startTime": undefined, "endTime": undefined};
      if (!this.form.effectiveTimeList) {
        this.form.effectiveTimeList = []
      }
      this.form.effectiveTimeList.push(data);
    },
    delUseTimeRange(index) {
      this.form.effectiveTimeList.splice(index, 1)
    },


    getCategoryNameById(id) {
      if (!id) {
        return "";
      }
      let cateInfo = this.categoryList.find(e => e.id === id);
      if (cateInfo) {
        return cateInfo.categoryName
      } else {
        return "";
      }
    },

    getCateList() {
      listCategory().then(response => {
        this.categoryList = response.data;
        const cate = { id: "0", categoryName: this.$t('根节点'), children: [] }
        cate.children = this.handleTree(response.data, 'id','pid')
        this.cateOptions.push(cate)
      })
    },
    getBrandList() {
      allBrand().then(response => {
        this.brandList = response.data
      })
    },
    getBrandNameById(id) {
      if (!id) {
        return "";
      }
      let brandInfo = this.brandList.find(e => e.id === id);
      if (brandInfo) {
        return brandInfo.name
      } else {
        return "";
      }
    },
    indexGoodsModalSelect(records) {
      this.form.goodsList = records
      console.log('商品选择了',this.form.goodsList)
    },
    openProdSelect() {
      this.$refs.CheckboxGoodsSelectForm.openGoods(false, this.form.goodsList, 100, [11], false);
    },


    // oss 上传开始
    async handlePreview(file) {
      let suffix = file.name.substring(file.name.lastIndexOf('.'));
      if (suffix === '.mp4') {
        this.handleVideoPreview(file);
      } else {
        this.handleImagePreview(file);
      }
    },

    async handleVideoPreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewVideoVisible = true
    },
    async handleImagePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewImageVisible = true
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    // 上传之前校验
    beforeOssUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 20
      // if (!isJPG) {
      //     this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 20MB!')
      }
      return isLt2M
    },
    // 上传覆盖默认的上传行为
    coverImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'activity'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'coverPic', res)
          _this.$message.success(this.$t('上传成功'),)
        })
      })
    },
    coverDetailImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'activity'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'posterPic', res)
          _this.$message.success(this.$t('上传成功'),)
        })
      })
    },
    // oss 上传结束

    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    initLocale() {
      //初始化多语言
      let localeList = [];
      let i = 1 ;
      this.customDict.LocaleEnum.forEach(e=>{
        localeList.push({"id":i ,"locale":e.type,'posterTxt':null,"activityName":null })
        i++;
      })
      this.form.localeList = localeList;
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getActivity({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      if (this.form.goodsList.length === 0) {
        this.$message.error('Please Select Products', 3)
        return false;
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateActivity(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addActivity(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      });
    }
  }
}
</script>
